/** @format */

import { useMenuStoreWithOut } from '@/store/modules/menu';
const ENABLE_PERMISSION = true;
const PERMISSION_EFFECT = 'hidden';

/**
 * 获取权限值
 */
export function getPermissionKey({ code, permission }, identity) {
	if (permission) {
		return permission;
	}
	if (identity) {
		// 有别名拼接别名
		return `${identity}:${code}`;
	}
	return;
}

/**
 * 是否有权限
 * @param {*} permissionKey
 */
export function hasPermission(permissionKey) {
	if (!ENABLE_PERMISSION || !permissionKey) {
		return true;
	}

	let hasRights = false;
	const permissions = getPermissions(useMenuStoreWithOut().menusRes);
	if (
		permissionKey &&
		permissionKey.length > 0 &&
		(permissionKey instanceof Array || Object.prototype.toString.call(permissionKey) === '[object String]')
	) {
		if (permissionKey instanceof Array) {
			hasRights = permissionKey.some((v) => {
				return permissions[v];
			});
		} else {
			hasRights = permissions[permissionKey];
		}
	}
	return hasRights;
}
export function getPermissions(menuList) {
	const permissions = {};
	if (!menuList || menuList.length <= 0) {
		return permissions;
	}
	const code = 'apiPermissions';
	menuList.forEach((menu) => {
		permissions[menu[code]] = true;
	});
	return permissions;
}
/**
 * 检测右键菜单的是否有权限
 */
export function checkContextmenuPermission(contextmenuList, identity, params) {
	if (!params) {
		params = {
			accessControl: true,
		};
	}
	// const isSuper = store.getters && store.getters.isSuper;
	if (!ENABLE_PERMISSION || !params.accessControl) {
		return contextmenuList;
	}
	const list = [];
	for (let i = 0; i < contextmenuList.length; i++) {
		const contextmenu = contextmenuList[i];
		const permissionKey = getPermissionKey(contextmenu, identity);
		const hasRights = hasPermission(permissionKey);
		if (hasRights) {
			list.push(contextmenu);
		} else {
			if (PERMISSION_EFFECT === 'disabled') {
				contextmenu.disabled = !hasRights;
				list.push(contextmenu);
			}
		}
	}
	return list;
}

/**
 * 是否有按钮的权限
 * @param {*} action
 * @param {*} identity
 */
export function hasActionPermission(action, identity) {
	if (ENABLE_PERMISSION && PERMISSION_EFFECT === 'hidden') {
		return hasPermission(getPermissionKey(action, identity));
	} else {
		return true;
	}
}
